import { Controller } from '@hotwired/stimulus';
import { useTransition } from 'stimulus-use';

export default class extends Controller {
  connect() {
    window.addEventListener('turbo:morph', () => {
      this.enable();
    });
    this.enable();
  }

  enable() {
    useTransition(this, { element: this.element });
  }

  enter() {
    this.enter();
  }

  leave() {
    this.leave();
  }
}
